var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
import * as React from "react";
import { useCallback, useEffect, useRef, useState, useMemo } from "react";
import { useTranslation } from "react-i18next";
import { Header } from "../../components/Header";
import { getGenres, getMoviesList } from "../../services/movie.service";
import { useAuth } from "../../context/Auth";
import "./MoviesScreenStyles.css";
import "../../styles/general.css";
import { useRouter } from "../../context/Router";
import { useApp } from "../../context/App";
import { chunkArray, onMoviePress } from "../../utils/Helpers";
import { MovieRowView } from "../../components/views/movie/MovieRowView";
import { MovieFiltersView } from "../../components/views/filter/MovieFiltersView";
import { FooterView } from "../../components/views/footer/FooterView";
import { ScrollToTopButton } from "../../components/views/buttons/ScrollToTopButton";
import { focusManager } from "../../utils/Focus";
import { useTVScroll, isWithinPosterWindow } from "../../hooks/useTVScroll";
import { SkeletonContentLayout } from "../../components/views/SkeletonContentLayout";
import { useModalContext } from "../../context/ModalContext";
export var MoviesScreen = function () {
    var _a = useRouter(), route = _a.route, params = _a.params, navigate = _a.navigate;
    var _b = useTranslation(), t = _b.t, i18n = _b.i18n;
    var profile = useAuth().profile;
    var _c = useApp(), dispatch = _c.dispatch, genres = _c.genres;
    var _d = useState([]), movies = _d[0], setMovies = _d[1];
    var _e = useState(false), isLoading = _e[0], setIsLoading = _e[1];
    var _f = useState(true), hasMore = _f[0], setHasMore = _f[1];
    var _g = useState(false), cleared = _g[0], setCleared = _g[1];
    var _h = useState({ genres: [], dubbing: [] }), filters = _h[0], setFilters = _h[1];
    var _j = useState(8), loadedRowsCount = _j[0], setLoadedRowsCount = _j[1]; // Start with 8 rows
    var showModal = useModalContext().showModal;
    var prevRowsLengthRef = useRef(0);
    var hasLoadedOnceRef = useRef(false);
    var requestIdRef = useRef(0);
    var verticalRef = useRef(null);
    var movieTypeRef = useRef(params.movieType
        ? params.movieType
        : route === "movies"
            ? "movie"
            : "series");
    var mappedGenres = useMemo(function () { return genres.map(function (g) { return ({ id: g.id, name: g.name }); }); }, [genres]);
    var languageKeys = useMemo(function () { return Object.keys(t("dub_languages", { returnObjects: true })); }, [t]);
    var languages = useMemo(function () {
        return languageKeys.map(function (key) { return ({
            id: key,
            name: t("dub_languages." + key),
        }); });
    }, [languageKeys, t]);
    var handleChosenGenre = useCallback(function (genre) {
        setFilters(function (prev) {
            var genreId = genre.id;
            var isChosen = prev.genres.some(function (g) { return g.id === genreId; });
            if (isChosen) {
                return __assign(__assign({}, prev), { genres: prev.genres.filter(function (g) { return g.id !== genreId; }) });
            }
            return __assign(__assign({}, prev), { genres: __spreadArrays(prev.genres, [genre]) });
        });
    }, []);
    var handleChosenDubb = useCallback(function (dubb) {
        setFilters(function (prev) {
            var dubbId = dubb.id;
            var isChosen = prev.dubbing.some(function (d) { return d.id === dubbId; });
            if (isChosen) {
                return __assign(__assign({}, prev), { dubbing: prev.dubbing.filter(function (d) { return d.id !== dubbId; }) });
            }
            return __assign(__assign({}, prev), { dubbing: __spreadArrays(prev.dubbing, [dubb]) });
        });
    }, []);
    useEffect(function () {
        getGenres({ lang: i18n.language }).then(function (res) {
            dispatch({ type: "SET_GENRES", genres: res });
        });
    }, [i18n.language, dispatch]);
    var fetchMovies = useCallback(function (isInitial) {
        if (isInitial === void 0) { isInitial = false; }
        return __awaiter(void 0, void 0, void 0, function () {
            var requestId, limit, offset, genreIds, dubs, movieType, res, newItems_1, err_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!isInitial && (isLoading || !hasMore))
                            return [2 /*return*/];
                        setIsLoading(true);
                        requestId = ++requestIdRef.current;
                        limit = 45;
                        offset = isInitial ? 0 : movies.length;
                        genreIds = filters.genres.map(function (g) { return g.id; });
                        dubs = filters.dubbing.map(function (d) { return d.id; });
                        movieType = params.movieType
                            ? params.movieType
                            : route === "movies"
                                ? "movie"
                                : "series";
                        if (movieTypeRef.current !== movieType) {
                            setFilters({ genres: [], dubbing: [] });
                            movieTypeRef.current = movieType;
                        }
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, 4, 5]);
                        return [4 /*yield*/, getMoviesList({
                                lang: i18n.language,
                                limit: limit,
                                offset: offset,
                                movieType: movieType,
                                order: "newest",
                                genres: genreIds,
                                dubs: dubs,
                            })];
                    case 2:
                        res = _a.sent();
                        if (requestId !== requestIdRef.current)
                            return [2 /*return*/];
                        newItems_1 = res.items || [];
                        setMovies(function (prev) { return (isInitial ? newItems_1 : __spreadArrays(prev, newItems_1)); });
                        setHasMore(offset + newItems_1.length < res.count);
                        return [3 /*break*/, 5];
                    case 3:
                        err_1 = _a.sent();
                        console.error(err_1);
                        return [3 /*break*/, 5];
                    case 4:
                        if (requestId === requestIdRef.current) {
                            setIsLoading(false);
                            hasLoadedOnceRef.current = true;
                        }
                        return [7 /*endfinally*/];
                    case 5: return [2 /*return*/];
                }
            });
        });
    }, [
        filters,
        movies.length,
        isLoading,
        hasMore,
        params.movieType,
        route,
        i18n.language,
    ]);
    useEffect(function () {
        focusManager.manualFocus("main-navbar", movieTypeRef.current === "movie" ? 1 : 2);
    }, [focusManager]);
    useEffect(function () {
        setMovies([]);
        setHasMore(true);
        setLoadedRowsCount(8);
        setCleared(true);
    }, [
        profile,
        params.movieType,
        filters.genres,
        filters.dubbing,
        i18n.language,
    ]);
    useEffect(function () {
        if (cleared) {
            setCleared(false);
            fetchMovies(true);
        }
    }, [cleared]);
    var rows = useMemo(function () { return chunkArray(movies, 6); }, [movies]);
    useEffect(function () {
        for (var i = rows.length; i < prevRowsLengthRef.current; i++) {
            focusManager.removeGroup("row-" + i);
        }
        prevRowsLengthRef.current = rows.length;
        rows.slice(0, loadedRowsCount).forEach(function (_, index) {
            focusManager.registerGroup({
                name: "row-" + index,
                position: index + 100,
                itemHeight: 530,
                verticalContainer: verticalRef.current,
            });
        });
    }, [rows, loadedRowsCount]);
    var onEndReached = useCallback(function () {
        if (loadedRowsCount < rows.length) {
            setLoadedRowsCount(function (prev) { return prev + 4; });
        }
        else {
            fetchMovies();
        }
    }, [loadedRowsCount, rows.length, fetchMovies]);
    var handleMoviePress = useCallback(function (movie) {
        var result = onMoviePress(movie);
        if (result.type === "modal") {
            showModal(result.modalType);
            return;
        }
        navigate("watch", { slug: result.slug });
    }, [navigate, showModal]);
    var showInitialSkeleton = isLoading && movies.length === 0 && !hasLoadedOnceRef.current;
    var _k = useTVScroll({ onEndReached: onEndReached }), scrollToTopVisible = _k.scrollToTopVisible, focusedGroup = _k.focusedGroup;
    var focusedRowIndex = useMemo(function () {
        if (focusedGroup && focusedGroup.indexOf("row-") === 0) {
            var parsed = parseInt(focusedGroup.slice(4), 10);
            if (!Number.isNaN(parsed))
                return parsed;
        }
        return 0;
    }, [focusedGroup]);
    var renderedRows = useMemo(function () {
        return rows
            .slice(0, loadedRowsCount)
            .map(function (row, index) { return (React.createElement(MovieRowView, { key: index, index: index, movies: row, hasHorizontalScroll: false, active: isWithinPosterWindow(index, focusedRowIndex), onMoviePress: handleMoviePress })); });
    }, [rows, loadedRowsCount, handleMoviePress, focusedRowIndex]);
    return (React.createElement(React.Fragment, null,
        React.createElement(Header, null),
        React.createElement("div", { ref: verticalRef, className: "screen-container" },
            React.createElement("div", { className: "movies-container" }, showInitialSkeleton ? (React.createElement(SkeletonContentLayout, { skeletonCount: 6, showTitle: false, isMoviesScreen: true })) : (React.createElement(React.Fragment, null,
                React.createElement(MovieFiltersView, { genres: mappedGenres, languages: languages, filters: filters, handleChosenGenre: handleChosenGenre, handleChosenDubb: handleChosenDubb, handleClearFilters: function () {
                        return setFilters({ genres: [], dubbing: [] });
                    }, verticalContainer: verticalRef.current }),
                movies.length === 0 ? (React.createElement("div", null,
                    React.createElement("p", { className: "not-found" }, isLoading ? t("player.loading") : t("filters.not_found")))) : (renderedRows),
                (!hasMore || rows.length > 0) && React.createElement(FooterView, null))))),
        scrollToTopVisible && React.createElement(ScrollToTopButton, null)));
};



//////////////////
// WEBPACK FOOTER
// ./src/screens/MoviesScreen/MoviesScreen.tsx
// module id = 158
// module chunks = 1